import { IsNotEmpty, IsOptional, IsString } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateChapterStatusDto {
  @ApiProperty({
    type: 'string',
    description: 'Code du statut de chapitre',
    example: 'IN_PROGRESS',
  })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({
    type: 'string',
    description: 'Nom du statut de chapitre',
    example: 'En cours',
  })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string
}
